<p>device-page works!</p>
<pre>
{{data | json}}
</pre>